export const SiteConfig = {
	APIKey: 'nE4fdH5DEk15G1queIxKm2cwVfdNzWbJ28Itstvn',
	MapsAPIKey: 'AIzaSyDxu6lgPpwHajOalq6Tyt8EP4UuVwwBbeo',
	SignInURL: 'https://cardiovascularcare.auth.us-east-1.amazoncognito.com/login?client_id=7h6aha00ubdrp26bi6f1udk3eo&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://www.cardiovascularcareks.com/code',
	APIURL: 'https://4vdfvhycaj.execute-api.us-east-1.amazonaws.com/main/'
};